module.exports = __webpack_public_path__ + "static/media/leftbg.269b5c7f.png";